export const TOGGLE_MAIN_CLASS = 'TOGGLE_MAIN_CLASS';

export const TOGGLE_DARK_MODE = 'TOGGLE_DARK_MODE';
